import './index.css'

import React from 'react'
import type { NestingLabel } from 'types/track'
import { MAIN, NESTING_LABELS } from '@disco/constants/Nesting'
import ContextMenu from 'components/common/context-menu'
import Icon from 'components/ui/icon'
import Lozenge from 'components/ui/lozenge'
type Props = {
  label: NestingLabel
  onChange: (...args: Array<any>) => any
}

/**
 * A dropdown component for selecting nesting labels, displayed as a lozenge with a context menu
 * @param label - The currently selected nesting label
 * @param onChange - Callback function called when a new label is selected
 * @returns Dropdown component that shows available nesting labels or a static lozenge for MAIN label
 */
const NestingLabelDropdown = ({ label, onChange }: Props): React.ReactNode => {
  if (label === MAIN) {
    return <Lozenge color="gray" text={label} bold />
  }

  return (
    <>
      <ContextMenu
        getMenuOffset={() => ['0', '24px']}
        appearance="action-menu"
        customButton={
          <div>
            <Lozenge
              color="gray"
              text={label || 'Select version'}
              nodeRight={
                <Icon
                  className="ExplorerTrackVersionsButton__Arrow ExplorerTrackVersionsButton__Arrow--Open"
                  type="arrow-right-compact"
                  width={14}
                  height={14}
                />
              }
              bold
            />
          </div>
        }
        buttonClassName={'NestingLabelDropdown'}
        maxHeight={300}
      >
        {({ closeMenu }) =>
          NESTING_LABELS.map(item => {
            return (
              <span
                key={item}
                className="context-menu__option"
                onClick={() => {
                  onChange(item)
                  closeMenu()
                }}
              >
                {item}
              </span>
            )
          })
        }
      </ContextMenu>
    </>
  )
}

export default NestingLabelDropdown
